<template>
  <div class='callData'>
      <div class='top'>
        <!-- <van-tabs v-model="active" title-active-color='#0A59F7' color='#0A59F7' background='transparent' :ellipsis='false' @change='onChange'>
                <van-tab name='1' title='正常通话'></van-tab>
                <van-tab name='2' title='拦截通话'></van-tab>
        </van-tabs> -->
          <p :class='{active:num==i+1}' @click='selectTab(i+1)' v-for='(item,i) in tabs' :key='i'><span>{{item}}</span></p>
      </div>
      <van-list v-model="isLoading" :finished='isFinish' @load='onLoad' :offset='70' :finished-text="finishText">
        <div class='list' v-for="(item,index) in list" :key='index'>
           <img :src='"@/assets/img/equipment/call"+item.type+".png"'>
           <div>
               <p  class='flex-between'>
                   <span :class="'txt font18 r'+item.type">{{item.callerName||'未知'}}</span><span class='time'>{{item.callTime}}</span>
               </p>
               <p  class='gray font15 flex-between' style="padding-top:.03rem">
                   <span>{{item.callerPhone}}</span><span class=''>{{item.duration}}</span>
               </p>
           </div>
        </div>
     </van-list>
    <div class='noData' v-if="text&&list.length==0"><div><img :src='require("@/assets/img/equipment/nodata1.png")'><br />{{text}}</div></div>
  </div>
</template>
<script>
import {contactsList} from "@/api/api.equipment";
  export default {
    data() {
      return {
        tabs:['正常通话','拦截通话'],
        list:[],
        isLoading:false,
        pageNo:1,
        pageSize:10,
        total:0,
        isFinish:true,
        finishText:'',
        text:'',
        num:1
      }
    },
   created(){
    //  this.form=sessionStorage.From||''
    //  if(this.from=='app'){
    //    edd_app.onTopPage(false);
    //  }
     this.getList();
    },
    methods: {
      selectTab(i){
        this.num=i;
        this.list=[];
        this.pageNo=1;
        this.isFinish=true;
        this.finishText='';
        this.text=='';
        this.total=0;
        this.getList();
      },
      getList(){
         contactsList({
              studentId:this.loginUser.studentId,
              type:this.num,
              pageNo:this.pageNo,
              pageSize:this.pageSize,
           }).then((data) => {
               if (data && data.result.list.length>0) {
                  this.list=this.list.concat(data.result.list);
              }
             this.isLoading=false;
             this.total=data.result.totalNum;
              if(this.total==this.list.length){
                this.isFinish=true;
                this.finishText=this.list.length>0?'-- 没有更多了 --':'';
              }else{
                this.isFinish=false;
              }
              if(this.pageNo==data.result.totalPage){
                this.isFinish=true;
                this.isLoading=false;
                this.finishText=this.list.length>0?'-- 没有更多了 --':'';
              }
              if(this.total==0){
                this.text='暂无通话'
              }
           })
       },
       onLoad(){
         if(this.isFinish) return
           this.pageNo++;
           this.getList();
         
       }
      
    },
  }
</script>
<style lang="scss" >
.callData{
  .top{
    background: #fff;
    color:#666;
    font-size: .15rem;
    border-bottom:1px solid rgba(0,0,0,.1);
    p{
         display: inline-block;
         font-size: .17rem;
         width: 50%;
         text-align: center;
         color: rgba(0,0,0,.9);
         span{
            padding:.1rem 0rem;
            display: inline-block;
         }
    }
    .active{
      color:#0A59F7;
      span{
        border-bottom: 2px solid #0A59F7;
      }
    }
  }
  .list{
    padding:.18rem .2rem .12rem;
    margin-bottom: 1px;
    line-height: 22px;
    color:#7F7F7F;
    font-size:.13rem;
    background:#fff;
    display: flex;
    align-items: center;
    
    img{
      width:.2rem;
      margin-right: .12rem;
    }
    div{
      flex:1;
    }
    .txt{
      color:rgba(0,0,0,.9);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // &.r3{
      //   color:#FF0000;
      // }
    }
    .time{
      color:rgba(0,0,0,0.4);
      font-size: .12rem;
    }
  }
  .font12{
    font-size:.12rem;
  }
}

</style>